import { render, staticRenderFns } from "./ViewDependents.vue?vue&type=template&id=95bba4f8&"
import script from "./ViewDependents.vue?vue&type=script&lang=js&"
export * from "./ViewDependents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports